import { render, staticRenderFns } from "./EssayTab.vue?vue&type=template&id=7b3c5464"
import script from "./EssayTab.vue?vue&type=script&lang=ts"
export * from "./EssayTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports